import React, { useEffect } from "react";
import "./Top_Filter_Div.css";
import Breadcrumb_comp from "../../common_components/breadcrumb-comp/Breadcrumb_comp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faSliders,
  faSortDown,
  faTableCells,
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Tab } from "react-bootstrap";
import Sort_by_Modal from "../../common_components/common_modal/sort_by_modal/Sort_by_Modal";
import { BestSuited, CategoryType } from "../../../features/master/masterSlice";
import { useDispatch, useSelector } from "react-redux";

const Top_Filter_Div_Wishlist = ({
  selectedOptions,
  setSelectedOptions,
  selectedOptionsBest,
  setSelectedOptionsBest,
  selectedOption,
  setSelectedOption,
  ...props
}) => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: props?.pageTitle, link: "", isActive: true },
  ];

  const [modalShow, setModalShow] = React.useState(false);

  return (
    <div className="top_filter_div">
      <div className="container">
        <div className="two_divs">
          <div className="breadcrump_div">
            <Breadcrumb_comp breadcrumbs={breadcrumbs} />
          </div>
          <div className="right_side_div">
            <div className="sort_div">
              <FontAwesomeIcon
                icon={faSliders}
                className="sort_icon mb-0"
                onClick={() => {
                  setModalShow(true);
                }}
              />
              <p
                className="sort_text"
                onClick={() => {
                  setModalShow(true);
                }}
              >
                Filter by
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* <Sort_by_Modal
        selectedOptions={selectedOptions}
        setSelectedOptions={setSelectedOptions}
        selectedOptionsBest={selectedOptionsBest}
        setSelectedOptionsBest={setSelectedOptionsBest}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        show={modalShow}
        onHide={() => setModalShow(false)}
      /> */}
    </div>
  );
};

export default Top_Filter_Div_Wishlist;
